require(
      "!../../../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../../../node_modules/json-loader/index.js!./content-type-sandbox-sample-embedded-page-did-you-know.json") })
        }
      }, "path---content-type-sandbox-sample-embedded-page-did-you-know");
     }
    


//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/gatsby-module-loader?name=path---content-type-sandbox-sample-embedded-page-did-you-know!./.cache/json/content-type-sandbox-sample-embedded-page-did-you-know.json
// module id = 2034
// module chunks = 231608221292675